var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { TextInput } from '../inputs';
import { validateUsername, validateUsernameV2 } from '../validations';
const NewUsername = (_a) => {
    var { 
    // NOTE: for instances where a NEW username is being created,
    // NOT for use when an existing username is being entered
    name, label = 'New username', badWords, contextualHelpContent = "4 to 28 characters. You'll use this name to log in.", shouldUseV2Validations = true } = _a, props = __rest(_a, ["name", "label", "badWords", "contextualHelpContent", "shouldUseV2Validations"]);
    const validateUsernameWrapper = (username) => shouldUseV2Validations
        ? validateUsernameV2(username, badWords)
        : validateUsername(username, badWords);
    return (React.createElement(TextInput, Object.assign({ name: name, labelContent: label, "data-allytmfn": "username", inputType: "text", validate: validateUsernameWrapper, required: true, contextualHelp: { variant: 'stacked', content: contextualHelpContent }, title: "Username", "data-testid": "create-new-username", "aria-required": "true" }, props)));
};
export default NewUsername;
//# sourceMappingURL=NewUsername.js.map